import React, {useState} from 'react';
import {Button, Card, Col, Modal, Row} from 'react-bootstrap';
import ElectricalServices from "@mui/icons-material/ElectricalServicesRounded";
import SwapHoriz from "@mui/icons-material/SwapHorizRounded";
import PropTypes from "prop-types";
import {getTenantErrorMessage, tenantsApi} from '../services/tenantsApi';
import {Dropdown} from '../../../shared/ui/Dropdown';
import CreateEdgeModal from './CreateEdgeModal';

const ROOT_TENANT_ID = 'wTh3EtamaQFzlkuMZspV';

const getId = (val) => val?.id || val;

const EdgesSection = ({tenant, path, subTenants, isOwner}) => {
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [edgeToTransfer, setEdgeToTransfer] = useState(null);
  const [transferTargetId, setTransferTargetId] = useState("");
  const [transferLoading, setTransferLoading] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const canCreateEdge = isOwner && tenant?.id === ROOT_TENANT_ID;

  const handleOpenTransfer = (edgeVal) => {
    setEdgeToTransfer(getId(edgeVal));
    setShowTransferModal(true);
  };

  const handleTransferEdge = async () => {
    if (!transferTargetId || !edgeToTransfer) return;
    setTransferLoading(true);
    const result = await tenantsApi.transferEdge({
      sourcePath: path,
      targetTenantId: transferTargetId,
      edgeId: edgeToTransfer
    });

    if (!result.ok) {
      alert(getTenantErrorMessage(result.error, 'Failed to transfer edge.'));
      setTransferLoading(false);
      return;
    }

    setShowTransferModal(false);
    setEdgeToTransfer(null);
    setTransferTargetId("");
    alert("Transfer successful");

    setTransferLoading(false);
  };

  return (<div className="mb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Assigned Edges</h4>
        {canCreateEdge && (<Button size="sm" onClick={() => {
          setShowCreateModal(true)
        }}>+ Create SCC</Button>)}

      </div>
      {(!tenant.edges || tenant.edges.length === 0) ? (
        <p className="text-muted">No edges assigned. Contact Global Admin to assign edges to this tenant.</p>) : (
        <Row xs={1} md={2} lg={3} className="g-3">
          {tenant.edges.map(edgeVal => {
            const edgeId = getId(edgeVal);
            return (<Col key={edgeId}>
              <Card className="island">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center" style={{maxWidth: '70%'}}>
                    <ElectricalServices className="me-2 text-warning"/>
                    <div className="text-truncate">
                      <Card.Title className="h6 mb-0 text-truncate" title={edgeId}>{edgeId}</Card.Title>
                    </div>
                  </div>
                  {isOwner && (
                    <Button variant="outline-secondary" size="sm" onClick={() => handleOpenTransfer(edgeVal)}>
                      <SwapHoriz fontSize="small" className="me-1"/> Transfer
                    </Button>)}
                </Card.Body>
              </Card>
            </Col>);
          })}
        </Row>)}

      <Modal show={showTransferModal} onHide={() => setShowTransferModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Transfer Edge</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Select the target sub-tenant to transfer edge <strong>{edgeToTransfer}</strong> to:</p>
          <Dropdown
            options={subTenants.map(sub => ({value: sub.id, label: sub.name || sub.id}))}
            value={transferTargetId}
            onChange={(val) => setTransferTargetId(val)}
            placeholder="Select Sub-Tenant..."
            block
          />
          <div className="mt-3 text-danger small">
            <small>Note: Transfers are irreversible from this view. You must access the sub-tenant to transfer it
              back.</small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTransferModal(false)}
                  disabled={transferLoading}>Cancel</Button>
          <Button variant="warning" onClick={handleTransferEdge} disabled={!transferTargetId || transferLoading}>
            {transferLoading ? 'Transferring...' : 'Transfer Edge'}
          </Button>
        </Modal.Footer>
      </Modal>

      <CreateEdgeModal show={showCreateModal} onHide={() => setShowCreateModal(false)} />

    </div>

  );
};

EdgesSection.propTypes = {
  tenant: PropTypes.shape({
    id: PropTypes.string,
    edges: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({id: PropTypes.string.isRequired})]))
  }).isRequired, path: PropTypes.string.isRequired, subTenants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired, name: PropTypes.string
  })).isRequired, isOwner: PropTypes.bool.isRequired
};

export default EdgesSection;
